function resizeRevSliderToHero() {
    const hero = document.querySelector('.hero');
    const slider = document.querySelector('sr7-module');

    if (!hero || !slider) return;

    const heroHeight = hero.offsetHeight;

    // Main wrapper
    slider.style.height = `${heroHeight}px`;

    // Internal Revolution layers
    const adjuster = slider.querySelector('sr7-adjuster');
    const content = slider.querySelector('sr7-content');
    const pxLayers = slider.querySelectorAll('sr7-px, sr7-bg, canvas');

    if (adjuster) adjuster.style.height = `${heroHeight}px`;
    if (content) content.style.height = `${heroHeight}px`;

    pxLayers.forEach(el => {
        el.style.height = `${heroHeight}px`;
    });
}

// // Initial call after slight delay (in case Rev Slider JS is applying its own height later)
// document.addEventListener('DOMContentLoaded', function () {
//     setTimeout(resizeRevSliderToHero, 200);
// });

// // Recalculate on window resize
// window.addEventListener('resize', resizeRevSliderToHero);

resizeRevSliderToHero();
